import moment from 'moment'

export default function shortDate(value) {
  return moment(value).format('MM/DD/YYYY hh:mm:ss A')
}



// WEBPACK FOOTER //
// ./src/filters/date/shortDate.js